//bao migrate skip
import * as ko from "knockout";
import * as $ from "jquery";
var bindingName = "baoSearcherControl";
function _defaults() {
    this.Enabled = true;
    this.readonly = true;
    this.GotoVisible = false;
    this.icons = {
        searchIcon: "fal fa-search",
        removeIcon: "fal fa-trash-alt",
        gotoIcon: "fal fa-arrow-circle-right"
    };
    this.BtnClass = "btn btn-default";
    this.searchFn = function () { };
    this.removeFn = function () { };
    this.gotoFn = function () { };
}
;
ko.bindingHandlers[bindingName] = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        createControl(element, valueAccessor);
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            var api = $(element).data(bindingName);
            $(api.$searchButton).remove();
            $(api.$gotoButton).remove();
            $(api.$removeButton).remove();
            api.__cleaner__();
            api.$container.remove();
        });
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var cfg = ko.createBindingConfig(valueAccessor(), new _defaults());
        $(element).data(bindingName).config = cfg;
        _toggleEnabled(element, valueAccessor, ko.unwrap(cfg.Enabled));
        _toggleGoto(element, valueAccessor, ko.unwrap(cfg.GotoVisible));
        _toggleReadonly(element, valueAccessor, ko.unwrap(cfg.readonly));
    },
    triggerSearch: triggerSearch,
    triggerRemove: triggerRemove,
    triggerGoto: triggerGoto
};
function triggerSearch(valueAccessor) {
    if (valueAccessor().searchFn != undefined) {
        valueAccessor().searchFn.apply(this);
    }
}
function triggerRemove(valueAccessor) {
    if (valueAccessor().removeFn != undefined) {
        valueAccessor().removeFn.apply(this);
    }
}
function triggerGoto(valueAccessor) {
    if (valueAccessor().gotoFn != undefined) {
        valueAccessor().gotoFn.apply(this);
    }
}
function _getClassSelector(className) {
    return "." + className.replace(" ", ".");
}
function _toggleGoto(element, valueAccessor, visible) {
    var api = $(element).data(bindingName);
    var _gotoButton = "<button class='" + api.config.BtnClass + "'><span class='" + api.config.icons.gotoIcon + "'></span></button>";
    var $button = $(_getClassSelector(api.config.icons.gotoIcon), api.$buttonContainer).parent();
    if (visible && $button.length == 0) {
        api.$buttonContainer.append(_gotoButton);
        api.$gotoButton = $(_getClassSelector(api.config.icons.gotoIcon), api.$buttonContainer).parent();
        api.$gotoButton.on("click", function (e) {
            ko.bindingHandlers[bindingName].triggerGoto.call(this, valueAccessor);
        });
        api.$container.addClass("input-group");
    }
    else if (visible == false && $button.length > 0) {
        $button.remove();
        delete api.$gotoButton;
    }
}
function _toggleEnabled(element, valueAccessor, enabled) {
    var api = $(element).data(bindingName);
    var _searchButton = "<button class='" + api.config.BtnClass + "'><span class='" + api.config.icons.searchIcon + "'></span></button>";
    var _removeButton = "<button class='" + api.config.BtnClass + "'><span class='" + api.config.icons.removeIcon + "'></span></button>";
    if (enabled && api.$searchButton == null) {
        api.$buttonContainer.prepend(_searchButton + _removeButton);
        api.$searchButton = $(".input-group-btn " + _getClassSelector(api.config.icons.searchIcon), api.$container).parent();
        api.$removeButton = $(".input-group-btn " + _getClassSelector(api.config.icons.removeIcon), api.$container).parent();
        api.$searchButton.on("click", function (e) {
            ko.bindingHandlers[bindingName].triggerSearch.call(this, valueAccessor);
        });
        api.$removeButton.on("click", function (e) {
            ko.bindingHandlers[bindingName].triggerRemove.call(this, valueAccessor);
        });
        api.$container.addClass("input-group");
    }
    else if (!enabled && api.$searchButton != null) {
        api.$searchButton.remove();
        api.$removeButton.remove();
        delete api.$searchButton;
        delete api.$removeButton;
    }
    if (!enabled && !ko.unwrap(api.config.GotoVisible)) {
        api.$container.removeClass("input-group");
    }
}

function _toggleReadonly(element, valueAccessor, readonly) {
    var api = $(element).data(bindingName);
    var isReaonly = $(element).is("[readonly]");
    if (readonly && !isReaonly) {
        $(element).attr("readonly", "readonly");
    }
    else if (!readonly && isReaonly) {
        $(element).removeAttr("readonly");
    }
}
function createControl(element, valueAccessor) {
    var _container = "<div class='input-group'></div>";
    var _buttonContainer = "<div class='input-group-btn'></div>";
    var api : any = {
        config: {},
        __cleaner__: ko.reattachHelper(element)
    };
    $(element).wrap(_container).after(_buttonContainer);
    api.$buttonContainer = $(element).next();
    api.$container = $(element).parent();
    $(element).data(bindingName, api);
}